import React from 'react';
import { fileAreaStyle, fileAreaWebExtra } from './styles';
import { loadImg, getImageStyle } from './utils';

// Renders an image file.
// Web-only element: <img> has no direct React Native equivalent.
// When porting to RN, replace with <Image source={{ uri }} /> from 'react-native'.
function ImagePreview({ file, width, height, onClick, innerRef }) {
  const sizeStyle = getImageStyle(file, width, height);

  return (
    <img
      ref={innerRef}
      src={loadImg(file)}
      alt={file?.name || file?.originalName}
      title={file?.name || file?.originalName}
      onClick={onClick}
      style={{
        ...fileAreaStyle,
        ...fileAreaWebExtra,
        ...sizeStyle,
        objectFit: 'cover'
      }}
    />
  );
}

export default ImagePreview;
